import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { DigiServiceService } from 'src/app/services/digi-service.service';
import { TransformerManagerService } from 'src/app/services/transformerManager.service';
import { DigiManagerComponent } from '../digi-manager.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-edit-digi-manager',
  templateUrl: './add-edit-digi-manager.component.html',
  styleUrls: ['./add-edit-digi-manager.component.scss']
})
export class AddEditDigiManagerComponent implements OnInit {

  fuelTypes = ['Diesel', 'Petrol', 'Gas', 'Other'];
  phaseTypes = ['Single Phase', 'Three Phase'];
  statuses = ['Active', 'Inactive', 'Under Maintenance'];

  generatorForm!: FormGroup;
  parameterForm!: FormGroup;
  alertParameterForm!: FormGroup;
  alertNotificationForm!: FormGroup;

  defaultParams = [
    'PF', 'KWH', 'RPM', 'KVAH',
    'KVARH', 'Gen_Hz', 'Oil_Temp', 'Total_KW',
    'Total_KVA', 'Fuel_Level', 'L1_Current', 'L1_Voltage',
    'L2_Current', 'L2_Voltage', 'L3_Current', 'L3_Voltage',
    'Total_KVAR', 'L1L2_Voltage', 'L2L3_Voltage', 'L3L1_Voltage'
  ];

  deviceMaster: any;

  constructor(
    private fb: FormBuilder,
    private transformerMangService: TransformerManagerService,
    private digiDashbioard: DigiServiceService,
     private dialogRef: MatDialogRef<DigiManagerComponent>,
     @Inject(MAT_DIALOG_DATA) public gididata,
  ) {
    // ✅ Generator Form
    this.generatorForm = this.fb.group({
      generatorId: ['', Validators.required],
      installationDate: ['', Validators.required],
      capacity: ['', Validators.required],
      fuelType: ['', Validators.required],
      manufacturerName: ['', Validators.required],
      modelNumber: ['', Validators.required],
      ratedVoltage: ['', Validators.required],
      ratedCurrent: ['', Validators.required],
      ratedFrequency: ['', Validators.required],
      phaseType: ['', Validators.required],
      fuelTankCapacity: ['', Validators.required],
      status: ['', Validators.required],
      lastServiceDate: [''], // optional
      city:['',Validators.required],
      deviceId: ['', Validators.required], 
      fuelPrice:['',Validators.required]
    });

    // ✅ Parameters Form
    this.parameterForm = this.fb.group({
      parameters: this.fb.array([])
    });

    // initialize with default parameters
    this.defaultParams.forEach(p => {
      this.parameters.push(
        this.fb.group({
          name: [p, Validators.required],
          enabled: [true]
        })
      );
    });

    // ✅ Alert Parameters Form
    this.alertParameterForm = this.fb.group({
      alertParameters: this.fb.array([])
    });

    // Preload default parameters
    this.loadDefaultParams();

    // ✅ Alert Notifications Form
    this.alertNotificationForm = this.fb.group({
      emails: this.fb.array([
        this.fb.group({
          email: ['', [Validators.required, Validators.email]]
        })
      ])
    });
  }

  ngOnInit() {
    if(this.gididata.action=="edit"){
      let discription = JSON.parse(this.gididata.data.description);
      let alertParamsFromServer = JSON.parse(this.gididata.data.alertParameter);
      let ParamsFromServer = JSON.parse(this.gididata.data.parameters);
      let notificationFromServer = JSON.parse(this.gididata.data.alertNotification);

      this.generatorForm.patchValue(discription)
      

      const alertParametersFA = this.alertParameterForm.get('alertParameters') as FormArray;
      alertParametersFA.clear();
      alertParamsFromServer.alertParameters.forEach(param => {
        alertParametersFA.push(this.createeditParameter(param));
      });

      const ParametersFA = this.parameterForm.get('parameters') as FormArray;
      ParametersFA.clear();
      ParamsFromServer.parameters.forEach(param => {
        ParametersFA.push(this.fb.group({
          name: [param.name, Validators.required],
          enabled: [param.enabled]
        }));
      });


      const notificationFA = this.alertNotificationForm.get('emails') as FormArray;
      notificationFA.clear();
      notificationFromServer.alertNotifications.forEach(param => {
        notificationFA.push(this.fb.group({
          email: [param.email, [Validators.required, Validators.email]]
        }));
      });
    }

    this.getDeviceDdl();
    this.getParameters();
  }

  getDeviceDdl() {
    this.transformerMangService.getDeviceDdl().toPromise().then((response: any) => {
      this.deviceMaster = response.data.deviceId;
    })
  }

  getParameters() {
    this.digiDashbioard.getDigiParameters().toPromise().then((response: any) => {
      console.log(response)
    })
  }

  // -------- Parameters --------
  get parameters(): FormArray {
    return this.parameterForm.get('parameters') as FormArray;
  }

  addParameter() {
    this.parameters.push(
      this.fb.group({
        name: ['', Validators.required],
        enabled: [true]
      })
    );
  }

  removeParameter(index: number) {
    this.parameters.removeAt(index);
  }

  // -------- Alert Parameters --------
  get alertParameters(): FormArray {
    return this.alertParameterForm.get('alertParameters') as FormArray;
  }

  createParameter(name: string): FormGroup {
    return this.fb.group({
      name: [{ value: name, disabled: true }, Validators.required], // keep required
      threshold: ['', Validators.required],
      emailToggle: [false]
    });
  }
  createeditParameter(data): FormGroup {
    return this.fb.group({
      name: [{ value: data.name, disabled: true }, Validators.required], // keep required
      threshold: [data.threshold, Validators.required],
      emailToggle: [data.emailToggle]
    });
  }
  loadDefaultParams(): void {
    this.defaultParams.forEach(param => {
      this.alertParameters.push(this.createParameter(param));
    });
  }

  addalertParameter(name: string = ''): void {
    this.alertParameters.push(this.fb.group({
      name: [name, Validators.required],
      threshold: ['', Validators.required],
      emailToggle: [false]
    }));
  }

  removealertParameter(index: number): void {
    this.alertParameters.removeAt(index);
  }

  // -------- Alert Notifications --------
  get emailControls(): FormArray {
    return this.alertNotificationForm.get('emails') as FormArray;
  }

  addEmail(): void {
    if (this.emailControls.length < 5) {
      this.emailControls.push(
        this.fb.group({
          email: ['', [Validators.required, Validators.email]]
        })
      );
    }
  }

  removeEmail(index: number): void {
    this.emailControls.removeAt(index);
  }

  // -------- Save Validation --------
  isAllFormsValid(): boolean {
    return this.generatorForm.valid &&
           this.parameterForm.valid &&
           this.alertParameterForm.valid &&
           this.alertNotificationForm.valid;
  }

  saveData() {
    if (!this.isAllFormsValid()) return;

    const data = {
      description:this.generatorForm.value,
      ...this.parameterForm.getRawValue(),
      ...this.alertParameterForm.getRawValue(),
      ...this.alertNotificationForm.value
    };
    
    console.log('Saving Data:', data);
    // Call API here
    if(this.gididata.action!= "edit"){
        this.digiDashbioard.addGenerator(data).subscribe(resp=>{
          if(resp.status){
            Swal.fire({
              title: 'Success!',
              text: 'Digi Manager saved successfully.',
              icon: 'success',
              confirmButtonColor: '#4CAF50', // professional green
            });
            
            this.dialogRef.close(true);
          }
        })
    } else {
      this.digiDashbioard.UpdateGenerator(data).subscribe(resp=>{
        if(resp.status){
          Swal.fire({
            title: 'Success!',
            text: 'Digi Manager saved successfully.',
            icon: 'success',
            confirmButtonColor: '#4CAF50', // professional green
          });
          
          this.dialogRef.close(true);
        }
      })
    } 
  }
}
